import { Edge, Node } from 'reactflow'

import { Placement } from './getRelationType'

type MaybeNode = Node | null

export const createNewEdges = (
  node: Node,
  closestNode: MaybeNode,
  relationType: Placement | null,
  parent: MaybeNode
): Edge[] => {
  if (!closestNode) {
    return []
  }

  if (!relationType) {
    return []
  }

  // Don't create edges from the firehose if we are top / bottom / left of it.
  // You can't become a parent or sibling of the firehose - only a child
  if (closestNode.type === 'firehose' && ['left', 'top', 'bottom'].includes(relationType)) {
    return []
  }

  // Don't create edges from the right of a placeholder node. You can't chain from a placeholder.
  if (closestNode.type === 'placeholder' && ['right'].includes(relationType)) {
    return []
  }
  const newEdges: Edge[] = []

  // return edges based on the relation type
  // For left relations, we need to create two edges to inject our dragged node in between the parent and closest node
  // For right relations, we create one edge and place the dragged node as a child of the closest node
  // for top and bottom relations, we create one edge and place the dragged node as a sibling / child of the parent
  switch (relationType) {
    case 'left':
      if (parent) {
        newEdges.push({
          id: `${parent.id}=>${node.id}`,
          source: parent.id,
          target: node.id,
          animated: true,
          type: 'drag',
        })

        newEdges.push({
          id: `${node.id}=>${closestNode.id}`,
          source: node.id,
          target: closestNode.id,
          animated: true,
          type: 'drag',
        })
      }
      break
    case 'right':
      newEdges.push({
        id: `${closestNode.id}=>${node.id}`,
        source: closestNode.id,
        target: node.id,
        animated: true,
        type: 'drag',
      })
      break
    case 'top':
    case 'bottom':
      if (parent) {
        newEdges.push({
          id: `${parent.id}=>${node.id}`,
          source: parent.id,
          target: node.id,
          animated: true,
          type: 'drag',
        })
      }
      break
  }

  return newEdges
}
